import React, { useContext } from "react";
import { GameStatus, QuestionStatus } from "../constants";
import missionElementsReducer from "./missionElementsReducer";
import { useGameStatusContext } from "./gameStatusProvider";
import { useProgressContext } from "./progressProvider";
import { useTimerContext } from "./timerProvider";
const initialState = {};

const missionElementsContext = React.createContext(initialState);

const initReducerState = (elements, options) => () => {
  const mapElements = (el) => {
    const mapRound = (q) => {
      return {
        ...q,
        id: createUUID(),
        status: QuestionStatus.AVAILABLE,
        dispatchedOn: null,
        ttl: q.ttl || options.defaultQuestionTTL,
        value: q.value || options.defaultQuestionScoreValue,
      };
    };

    return {
      ...el,
      questions: {
        firstRound: el.questions.firstRound.map(mapRound),
        secondRound: el.questions.secondRound.map(mapRound),
      },
    };
  };

  return elements.map(mapElements);
};

function MissionElementsProvider({ elements, options, children }) {
  // States
  const [currentlyDispatched, setCurrentlyDispatched] = React.useState([]);
  const [need, setNeed] = React.useState(
    options.availableQuestionsAtaTime || 4
  );

  // Providers
  const [gameStatus, setGameStatus] = useGameStatusContext();
  const [progress, setProgress] = useProgressContext();
  //const secondsCount = useTimerContext();
  const [totalQuestions, setTotalQuestions] = React.useState(0);

  // reducers
  const [stateElements, dispatch] = React.useReducer(
    missionElementsReducer,
    [],
    initReducerState(elements, options)
  );

  React.useEffect(() => {
    let score = 0;
    let totalScore = 0;
    let totalQs = 0;

    // eslint-disable-next-line array-callback-return
    stateElements &&
      stateElements.map((e) => {
   
        e.questions[gameStatus.round].forEach((q) => {
          // eslint-disable-next-line default-case
          totalQs += 1;
          totalScore += q.value;
          // eslint-disable-next-line default-case
          switch (q.status) {
            case QuestionStatus.ANSWERED_RIGHT:
              score += q.value;
              totalQs -= 1;
              break;
            case QuestionStatus.ANSWERED_WRONG:
              score -= 0;
              totalQs -= 1;
              break;
            // case QuestionStatus.TIMED_OUT:
            //   score -= options.defaultTimedOutQuestionScoreValue;
          }
        });
      });

    setTotalQuestions(totalQs)
    setGameStatus({
      ...gameStatus,
      score,
      totalScore,
    });
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [stateElements]);

  React.useEffect(() => {
    if (gameStatus.status === GameStatus.STARTED) {
      // Kep Track of elements with still available questions
      const availableElements = [];

      stateElements.forEach((e) => {
        const avails = e.questions[gameStatus.round].find(
          (q) => q.status === QuestionStatus.AVAILABLE
        );
        if (avails) availableElements.push(e);
      });

      let availableCount = 0;
      availableElements.forEach((e) => {      
        const avails = e.questions[gameStatus.round].filter(
          (q) => q.status === QuestionStatus.AVAILABLE
        );
        availableCount += avails.length;
      });

      // Kep Track of elements with still dispatched (current) questions
      const dispatchedElements = [];
      stateElements.forEach((e) => {
        const dispatched = e.questions[gameStatus.round].find(
          (q) => q.status === QuestionStatus.DISPATCHED
        );      
        if (dispatched) {
          dispatchedElements.push(e);
        }
      });

      let dispatchedCount = 0;
      dispatchedElements.forEach((e) => {
        const dispatched = e.questions[gameStatus.round].filter(
          (q) => q.status === QuestionStatus.DISPATCHED
        );
        dispatchedCount += dispatched.length;
      });

      let total = 0;
      stateElements.forEach((e) => {
        total += e.questions[gameStatus.round].length;
      });

      setCurrentlyDispatched(dispatchedElements);
      console.log("options.availableQuestionsAtaTime" , options.availableQuestionsAtaTime);
      console.log("dispatchedElements.length" , dispatchedElements.length);
      //if(gameStatus.round === 'firstRound'){
          setNeed(options.availableQuestionsAtaTime - dispatchedElements.length);
      // }else{
      //   if(totalQuestions <= options.availableQuestionsAtaTime)
      //     setNeed(0);
      // }

      setProgress({
        ...progress,
        available: availableCount,
        dispatched: dispatchedCount,
        total,
      });

      setTimeout(() => {
        //if (availableElements.length === 0 && dispatchedElements.length === 0) {
        if (totalQuestions === 0) {          
          console.groupEnd();
          setGameStatus({
            ...gameStatus,
            status: GameStatus.FINISHED,
          });
        }
      }, 1000);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [stateElements, gameStatus]);

  React.useEffect(() => {
    if (gameStatus.status === GameStatus.STARTED) {
      const expiredQuestions = [];
      currentlyDispatched.forEach((e) => {
        const dispatched = e.questions[gameStatus.round].filter(
          (q) => q.status === QuestionStatus.DISPATCHED
        );
        dispatched &&
          dispatched.forEach((q) => {
            // const elapsed = new Date().getTime() - q.dispatchedOn;
            // if (elapsed > (q.ttl || options.defaultQuestionTTL) * 1000) {
            //   expiredQuestions.push(q);
            // }
          });
      });
      dispatch({
        type: "SET_QUESTION_STATUS",
        payload: {
          options,
          round: gameStatus.round,
          questions: expiredQuestions,
          status: QuestionStatus.TIMED_OUT,
        },
      });
      // let question status sink in and fetch new.
    
      if (need > 0 ) {
        console.log("get it!" );
        console.log("totalQuestions" , totalQuestions);
        console.log("options.availableQuestionsAtaTime" , options.availableQuestionsAtaTime);
        //if(totalQuestions >= options.availableQuestionsAtaTime && gameStatus.round !== 'secondRound' ){
        if(totalQuestions > 0){
          dispatch({
            type: "FETCH_QUESTION",
            payload: {
              need,
              options,
              round: gameStatus.round,
            },
          });
        }
      }
    }

  // }, [gameStatus.status]);
  }, [gameStatus.status, need]);

  return (
    <missionElementsContext.Provider value={[stateElements, dispatch]}>
      {children}
    </missionElementsContext.Provider>
  );
}

function createUUID() {
  return "_" + Math.random().toString(36).substr(2, 9);
}

export const useMissionElementsContext = () =>
  useContext(missionElementsContext);

export default MissionElementsProvider;
